import { render } from "./Clip.vue?vue&type=template&id=3b4920df"
import script from "./Clip.vue?vue&type=script&lang=js"
export * from "./Clip.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__